// extracted by mini-css-extract-plugin
export var mainContainer = "layout-module--main-container--1steW";